import { redirect, createFileRoute } from '@tanstack/react-router'
import { getStoreTabFromPersistence } from '@/features/store/use-store-launch'
import { getOidc } from '@/features/oidc/oidc'

export const Route = createFileRoute('/_app/store')({
  beforeLoad: async ({ search, matches, location }) => {
    // only on exact match on this route, not the child
    if (matches.at(-1)?.id === Route.id) {
      const oidc = await getOidc()

      if (oidc.isUserLoggedIn) {
        const aid = oidc.getDecodedIdToken()['pam-aid']
        const storeTab = getStoreTabFromPersistence(aid)

        throw redirect({
          to:
            storeTab === 'buy-gold-coins'
              ? '/store/buy-gold-coins'
              : '/store/play-for-free',
          search,
          state: {
            ...location.state,
            from: location.state.from ? location.state.from : 'deeplink',
          },
        })
      }
    }
  },
})
